<template>
    <div class="page-goods">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>管理系统</el-breadcrumb-item>
            <el-breadcrumb-item>{{
                $route.meta.breadcrumb
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="page-title">{{ $route.meta.title }}</h1>

        <div class="content-card">
            <div class="toolbar-row">
                <div class="filter-row">
                    <el-input
                        v-model="search"
                        class="filter-input"
                        clearable
                        placeholder="输入商品名称/编号"
                        @keyup.enter.native="onSearch"
                        prefix-icon="el-icon-search"
                    />
                    <el-select
                        @change="onSearch"
                        v-model="productTypeFilter"
                        placeholder="展示类型"
                        class="filter-select"
                    >
                        <el-option label="全部类型" value="" />
                        <el-option label="话费" value="0" />
                        <el-option label="交联券" value="1" />
                    </el-select>
                    <el-select
                        @change="onSearch"
                        v-model="businessTypeFilter"
                        placeholder="业务类型"
                        class="filter-select"
                    >
                        <el-option label="全部业务" value="" />
                        <el-option label="线上" value="0" />
                        <el-option label="线下" value="1" />
                    </el-select>
                    <el-select
                        @change="onSearch"
                        v-model="stateFilter"
                        placeholder="商品状态"
                        class="filter-select"
                    >
                        <el-option label="全部状态" value="" />
                        <el-option label="启用" value="1" />
                        <el-option label="停用" value="0" />
                    </el-select>
                    <div class="score-range">
                        <span class="score-label">积分</span>
                        <el-input
                            v-model.number="scoreMin"
                            type="number"
                            placeholder="最低"
                            class="score-input"
                            @keyup.enter.native="onSearch"
                            @change="onSearch"
                            clearable
                        />
                        <span class="score-sep">~</span>
                        <el-input
                            v-model.number="scoreMax"
                            type="number"
                            placeholder="最高"
                            class="score-input"
                            @keyup.enter.native="onSearch"
                            @change="onSearch"
                            clearable
                        />
                    </div>
                    <div class="filter-actions">
                        <el-button
                            class="btn-black"
                            type="primary"
                            icon="el-icon-search"
                            @click="onSearch"
                            >查询</el-button
                        >
                        <el-button
                            icon="el-icon-refresh"
                            @click="handleResetFilters"
                            >重置</el-button
                        >
                    </div>
                </div>
                <div class="toolbar-actions">
                    <!-- <el-button class="btn-black" type="primary" icon="el-icon-plus" @click="openAddDialog">
                        新增商品
                    </el-button> -->
                    <el-button icon="el-icon-upload2" @click="handleExport"
                        >导出</el-button
                    >

                    <el-button
                        icon="el-icon-refresh"
                        circle
                        @click="handleRefresh"
                    />
                </div>
            </div>

            <el-table
                :data="tableData"
                v-loading="loading"
                stripe
                border
                style="width: 100%"
                height="60vh"
            >
                <el-table-column
                    align="center"
                    prop="productNo"
                    label="商品编号"
                    width="150"
                />
                <el-table-column
                    align="center"
                    prop="productName"
                    label="商品名称"
                    min-width="200"
                />
                <el-table-column align="center" label="展示类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.productType === 0">话费</span>
                        <span v-else-if="scope.row.productType === 1"
                            >交联券</span
                        >
                        <span v-else>{{ scope.row.productType || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="业务类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.businessType === 0">线上</span>
                        <span v-else-if="scope.row.businessType === 1"
                            >线下</span
                        >
                        <span v-else>{{ scope.row.businessType || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="商品金额" width="130">
                    <template slot-scope="scope">
                        {{
                            scope.row.price != null
                                ? `¥${Number(scope.row.price).toLocaleString(
                                      'zh-CN',
                                      {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                      }
                                  )}`
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="productPoint"
                    label="积分"
                    width="100"
                />
                <el-table-column align="center" label="商品状态" width="120">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.state === 1"
                            type="success"
                            size="small"
                            >启用</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.state === 0"
                            type="danger"
                            size="small"
                            >停用</el-tag
                        >
                        <span v-else>{{ scope.row.state || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="remark"
                    label="商品描述"
                    min-width="160"
                    show-overflow-tooltip
                />
                <el-table-column
                    align="center"
                    label="操作"
                    width="160"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleView(scope.row)"
                        ></el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        ></el-button>
                        <el-button
                            type="text"
                            :class="
                                scope.row.state === 1
                                    ? 'text-warning-action'
                                    : 'text-success-action'
                            "
                            :icon="
                                scope.row.state === 1
                                    ? 'el-icon-lock'
                                    : 'el-icon-unlock'
                            "
                            @click="handleToggleStatus(scope.row)"
                        >
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-bar">
                <span class="pagination-info">共 {{ total }} 条</span>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @current-change="fetchData"
                />
            </div>
        </div>

        <el-dialog
            :title="isEdit ? '编辑商品' : '新增商品'"
            :visible.sync="addDialogVisible"
            width="600px"
            custom-class="add-goods-dialog"
            :close-on-click-modal="false"
            @closed="onAddDialogClosed"
        >
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="addFormRules"
                label-position="top"
                class="add-goods-form"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="商品编号" v-if="isEdit">
                            <el-input v-model="addForm.productNo" disabled />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品名称" prop="productName">
                            <el-input
                                v-model="addForm.productName"
                                :disabled="isEdit"
                                clearable
                                placeholder="请输入商品名称"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品金额" prop="productPrice">
                            <div class="amount-with-prefix">
                                <span class="amount-prefix">¥</span>
                                <el-input-number
                                    v-model="addForm.productPrice"
                                    :precision="2"
                                    :step="10"
                                    :min="0"
                                    :controls="false"
                                    placeholder="0.00"
                                    class="amount-input-number"
                                />
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="展示类型" prop="productType">
                            <el-select
                                v-model="addForm.productType"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option label="话费" value="0" />
                                <el-option label="交联券" value="1" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="业务类型" prop="businessType">
                            <el-select
                                v-model="addForm.businessType"
                                placeholder="请选择"
                                style="width: 100%"
                            >
                                <el-option label="线上" value="0" />
                                <el-option label="线下" value="1" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="积分" prop="productScore">
                            <el-input-number
                                v-model="addForm.productScore"
                                :precision="0"
                                :min="0"
                                :controls="false"
                                placeholder="0"
                                style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品状态">
                            <el-radio-group
                                v-model="addForm.state"
                                class="status-radio-group"
                            >
                                <el-radio :label="'1'">启用</el-radio>
                                <el-radio :label="'0'">停用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="商品说明">
                    <el-input
                        v-model="addForm.productDesc"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入商品说明"
                    />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="addSubmitting"
                    @click="submitAddGoods"
                >
                    {{ isEdit ? '保存修改' : '确定创建' }}
                </el-button>
            </span>
        </el-dialog>

        <!-- 查看商品详情弹窗 -->
        <el-dialog
            title="商品详情"
            :visible.sync="viewDialogVisible"
            width="700px"
            custom-class="view-goods-dialog"
            :close-on-click-modal="false"
        >
            <div v-if="viewData" class="view-goods-body">
                <el-descriptions
                    :column="2"
                    border
                    size="small"
                    class="goods-detail-descriptions"
                >
                    <el-descriptions-item :span="1" label="商品编号">{{
                        viewData.productNo || '-'
                    }}</el-descriptions-item>
                    <el-descriptions-item :span="1" label="商品名称">{{
                        viewData.productName || '-'
                    }}</el-descriptions-item>
                    <el-descriptions-item label="展示类型">
                        <span v-if="String(viewData.productType) === '0'"
                            >话费</span
                        >
                        <span v-else-if="String(viewData.productType) === '1'"
                            >交联券</span
                        >
                        <span v-else>{{ viewData.productType || '-' }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="业务类型">
                        <span v-if="String(viewData.businessType) === '0'"
                            >线上</span
                        >
                        <span v-else-if="String(viewData.businessType) === '1'"
                            >线下</span
                        >
                        <span v-else>{{ viewData.businessType || '-' }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="实际扣款价">
                        {{
                            viewData.price != null
                                ? `¥${Number(viewData.price).toLocaleString(
                                      'zh-CN',
                                      {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                      }
                                  )}`
                                : '-'
                        }}
                    </el-descriptions-item>
                    <el-descriptions-item label="积分">{{
                        viewData.productPoint != null
                            ? viewData.productPoint
                            : '-'
                    }}</el-descriptions-item>
                    <el-descriptions-item label="商品状态">
                        <el-tag
                            v-if="String(viewData.state) === '1'"
                            type="success"
                            size="small"
                            >启用</el-tag
                        >
                        <el-tag
                            v-else-if="String(viewData.state) === '0'"
                            type="danger"
                            size="small"
                            >停用</el-tag
                        >
                        <span v-else>{{ viewData.state || '-' }}</span>
                    </el-descriptions-item>
                </el-descriptions>
                <div class="goods-detail-remark" v-if="viewData.remark">
                    <span class="remark-label">商品说明</span>
                    <div class="remark-content">{{ viewData.remark }}</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getGoodsList,
    getGoodsDetail,
    addGoods,
    updateGoods,
    exportGoods
} from '@/api/goods'

export default {
    name: 'Goods',
    data() {
        return {
            search: '',
            productTypeFilter: '',
            businessTypeFilter: '',
            stateFilter: '',
            scoreMin: null,
            scoreMax: null,
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            multipleSelection: [],
            viewDialogVisible: false,
            viewData: null,
            addDialogVisible: false,
            addSubmitting: false,
            isEdit: false,
            editingGoodsId: null,

            addForm: {
                productNo: '',
                productName: '',
                productPrice: 0,
                productType: '',
                businessType: '',
                state: '1',
                productScore: 0,
                productDesc: ''
            },
            addFormRules: {
                productName: [
                    {
                        required: true,
                        message: '请输入商品名称',
                        trigger: 'blur'
                    }
                ],
                productPrice: [
                    {
                        required: true,
                        message: '请输入商品金额',
                        trigger: 'blur'
                    }
                ],
                productType: [
                    {
                        required: true,
                        message: '请选择展示类型',
                        trigger: 'change'
                    }
                ],
                businessType: [
                    {
                        required: true,
                        message: '请选择业务类型',
                        trigger: 'change'
                    }
                ]
            },
            tableData: []
        }
    },
    mounted() {
        this.onSearch()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const result = await getGoodsList({
                    searchValue: this.search,
                    productType: this.productTypeFilter,
                    businessType: this.businessTypeFilter,
                    state: this.stateFilter,
                    minPoint: this.scoreMin,
                    maxPoint: this.scoreMax,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                this.tableData = result.rows
                this.total = result.total || 0
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.loading = false
            }
        },
        async handleView(row) {
            try {
                const res = await getGoodsDetail(row.productNo)
                this.viewData = res.data
            } catch {
                this.viewData = row
            }
            this.viewDialogVisible = true
        },
        handleToggleStatus(row) {
            const newState = String(row.state) === '1' ? '0' : '1'
            const label = newState === '1' ? '启用' : '停用'
            this.$confirm(
                `确定${label}商品「${row.productName}」？`,
                '状态确认',
                {
                    type: 'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }
            )
                .then(async () => {
                    try {
                        await updateGoods({
                            productNo: row.productNo,
                            state: newState
                        })
                        this.$message.success(`${label}成功`)
                        this.fetchData()
                    } catch {
                        // 错误已在 request.js 响应拦截器中处理
                    }
                })
                .catch(() => {})
        },
        openAddDialog() {
            this.isEdit = false
            this.editingGoodsId = null
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                    this.$refs.addForm.resetFields()
                }
            })
        },
        async handleEdit(row) {
            this.isEdit = true
            this.editingGoodsId = row.id
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                }
            })
            try {
                const res = await getGoodsDetail(row.productNo)
                const data = res.data || res
                this.addForm = {
                    productNo: data.productNo,
                    productName: data.productName,
                    productPrice:
                        data.price != null ? data.price : row.productPrice,
                    productType: String(
                        data.productType != null
                            ? data.productType
                            : row.productType != null
                            ? row.productType
                            : ''
                    ),
                    businessType: String(
                        data.businessType != null
                            ? data.businessType
                            : row.businessType != null
                            ? row.businessType
                            : ''
                    ),
                    state: String(data.state != null ? data.state : '1'),
                    productScore:
                        data.productPoint != null
                            ? data.productPoint
                            : row.productScore,
                    productDesc: data.remark
                }
            } catch {
                // 接口失败时回退使用表格行数据
                this.addForm = {
                    productNo: row.productNo,
                    productName: row.productName,
                    productPrice: row.price,
                    productType: String(
                        row.productType != null ? row.productType : ''
                    ),
                    businessType: String(
                        row.businessType != null ? row.businessType : ''
                    ),
                    state: String(row.state != null ? row.state : '1'),
                    productScore: row.productPoint,
                    productDesc: row.remark || ''
                }
            }
        },
        onAddDialogClosed() {
            this.addSubmitting = false
            this.isEdit = false
            this.editingGoodsId = null
        },
        async submitAddGoods() {
            try {
                await this.$refs.addForm.validate()
            } catch {
                return
            }
            this.addSubmitting = true
            try {
                if (this.isEdit) {
                    await updateGoods({
                        id: this.editingGoodsId,
                        productNo: this.addForm.productNo,
                        productName: this.addForm.productName.trim(),
                        price: this.addForm.productPrice,
                        productPoint: this.addForm.productScore,
                        productType: this.addForm.productType,
                        businessType: this.addForm.businessType,
                        state: this.addForm.state,
                        remark: this.addForm.productDesc
                    })
                    this.$message.success('修改成功')
                } else {
                    await addGoods({
                        productName: this.addForm.productName.trim(),
                        productPrice: this.addForm.productPrice,
                        productType: this.addForm.productType,
                        businessType: this.addForm.businessType,
                        state: this.addForm.state,
                        productScore: this.addForm.productScore,
                        productDesc: this.addForm.productDesc
                    })
                    this.$message.success('新增商品成功')
                }
                this.addDialogVisible = false
                this.currentPage = 1
                this.fetchData()
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.addSubmitting = false
            }
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        handleRefresh() {
            this.fetchData()
        },
        handleResetFilters() {
            this.search = ''
            this.productTypeFilter = ''
            this.businessTypeFilter = ''
            this.stateFilter = ''
            this.scoreMin = null
            this.scoreMax = null
            this.currentPage = 1
            this.fetchData()
        },

        async handleExport() {
            this.loading = true
            try {
                const blob = await exportGoods({
                    productNo: this.search,
                    productType: this.productTypeFilter,
                    businessType: this.businessTypeFilter,
                    state: this.stateFilter,
                    productScoreMin: this.scoreMin,
                    productScoreMax: this.scoreMax
                })
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = '商品列表.xlsx'
                a.click()
                URL.revokeObjectURL(url)
                this.$message.success('导出成功')
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.filter-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

.filter-input {
    width: 180px;
}

.filter-select {
    width: 180px;
}

.filter-actions {
    display: flex;
    gap: 8px;
    margin-left: 8px;
}

.score-range {
    display: flex;
    align-items: center;
    gap: 6px;
}

.score-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.score-input {
    width: 120px;
}

.score-input >>> .el-input__inner {
    text-align: left;
}

.score-sep {
    color: #909399;
    font-size: 13px;
}

.pagination-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
}

.pagination-info {
    font-size: 13px;
    color: #606266;
}

.amount-with-prefix {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.amount-prefix {
    color: #909399;
    font-size: 14px;
    flex-shrink: 0;
}

.amount-input-number {
    flex: 1;
    width: 0;
}

.amount-input-number >>> .el-input__inner {
    text-align: left;
}
</style>

<style>
.add-goods-dialog .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 8px;
}

.add-goods-dialog .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.add-goods-dialog .status-radio-group {
    display: flex;
    gap: 12px;
    margin-top: 2px;
}

.view-goods-dialog .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 8px;
}

/* 修复商品详情描述表格 label 列宽被内容挤压的问题 */
.view-goods-dialog
    .goods-detail-descriptions
    .el-descriptions__body
    table.el-descriptions__table {
    table-layout: fixed;
}

.view-goods-dialog .goods-detail-descriptions .el-descriptions__cell.is-label {
    width: 100px !important;
    min-width: 100px !important;
    white-space: normal !important;
}

.view-goods-dialog
    .goods-detail-descriptions
    .el-descriptions__cell.is-content {
    word-break: break-all;
}

.view-goods-dialog .goods-detail-remark {
    margin-top: 16px;
    padding: 10px 14px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.view-goods-dialog .remark-label {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    display: block;
    margin-bottom: 6px;
}

.view-goods-dialog .remark-content {
    font-size: 13px;
    color: #303133;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
}

.page-goods .el-table__fixed-right {
    background: #fff;
    border-left: 1px solid #ebeef5;
}

.page-goods .el-table__fixed-right td,
.page-goods .el-table__fixed-right th {
    background: #fff;
}

.page-goods .el-table__body-wrapper .el-table__fixed-right .el-table__body {
    border-left: 1px solid #ebeef5;
}

.text-warning-action {
    color: #e6a23c !important;
}

.text-success-action {
    color: #67c23a !important;
}

.view-goods-body {
    padding: 4px 0;
}
</style>
